

<script>
import {Draggable, Droppable, Sortable, Swappable} from '@shopify/draggable';
import 'webpack-jquery-ui/sortable';

export default { 
   data() {
      return {
         durHour: 0,
         durMinute: 0,
         durSecond: 0
      }
   },

   props: {
      addRow: Boolean,
      slotObj: Object,
      asset: Object,
      status: String,
      isFeedSlot: {
         type: Boolean,
         required: false,
         default: false
      },
      expanded: false,
      assetRecid: Number | String,
      assetOriginRecid: Number | String,
      isTrigger: Boolean,
      active: Boolean,
      slotRecid: Number | String,
      atEnd: Boolean
   },

   computed: {
      assetTitle() {
         return this.slotObj.asset.description != '' && 
            this.slotObj.asset.description != undefined ? this.slotObj.asset.description : this.slotObj.asset.filename
      },

      fileType() {
         let fileType = '';
         switch(parseInt(this.slotObj.asset.asset_type)) {
            case 10:
               fileType = '.bard';
               break;
            case 6: 
               fileType = '.feed';
               break;
            default:
               if (this.slotObj.asset.filename) {
                  fileType = '.' + this.slotObj.asset.filename.split('.')[1];
               }
               break;
         }
         return fileType;
      },

   },

   created() {
      //convert duration seconds to HH-MM-SS string
      this.convertDuration();
   },

   methods: {
      // handleLoopCheck(target) {
      //    this.$parent.$emit('loopCheck', target.checked, this.assetRecid);
      // },

      // handleHotPickCheck(target) {
      //    this.$parent.$emit('hotPickCheck', target.checked, this.assetRecid);
      // },

      // handleNoAdsCheck(target) {
      //    this.$parent.$emit('noAdsCheck', target.checked, this.assetRecid);
      // },

      // handleDurationInput(input) {
      //    this.totalDuration = (this.durHour * 60 * 60) + (this.durMinute * 60) + (this.durSecond);
      // },

      convertDuration() {
         let time = this.slotObj.duration;
         let hours = Math.floor(time / 3600);
         time = time - hours * 3600;
         let minutes = Math.floor(time / 60);
         let seconds = time - minutes * 60;

         if (hours <= 9) {
            hours = "0" + hours;
         }
         this.durHour = hours;
         
         if (minutes <= 9) {
            minutes = "0" + minutes;
         }
         this.durMinute = minutes;

         if (seconds <= 9) {
            seconds = "0" + seconds;
         }
         this.durSecond = seconds;
      },

      // handleDurationChange() {
      //    // if (this.durHour == '') {
      //    //    this.durHour = 0;
      //    // }
      //    if (this.durMinute == '') {
      //       this.durMinute = 0;
      //    } 
      //    if (this.durSecond == '') {
      //       this.durSecond = 0;
      //    }
      //    //let totalDuration = (parseInt(this.durHour) * 60 * 60) + (parseInt(this.durMinute) * 60) + (parseInt(this.durSecond));
      //    let totalDuration = (parseInt(this.durMinute) * 60) + (parseInt(this.durSecond));
      //    this.$parent.$emit('durationChange', totalDuration, this.assetRecid);
      // },
   },

   watch: {
      slotObj: {
         handler() {
            this.convertDuration();
         },
         deep:true
      }
   },

   components: {
   }
}
</script>

<style lang="scss" scoped>
tr, td {
   &:focus {
      outline: none;
   }
}
table.table-inner {
   width: 100%;
   table-layout: fixed;
}
.table-row {
   // display: flex;
   justify-content: space-between;
   align-items: center;

   td {
      vertical-align: middle;
   }

   &.is_main_row {
      // border-top: 1px solid #354658;
      border-bottom: 1px solid #354658;
   }

   &.is_add_row {
      justify-content: unset;
   }

   &.active {
      border: 1px solid $bard-green;
   }
   
   background: transparent;
   position: relative;

   .invisible{
      visibility: hidden;
   }

   .order {
      text-align: center;
      width: 6%;
      padding: 0 10px;
   } 

   .asset {
      width: 30%;
   }

   // .scoreboard-details-msg {
   //    order: 3;
   //    font-size: 18px;
   //    opacity: .3;
   //    margin-left: -100px;
   // }

   .duration {
      width: 9%;
   }

   .asset-type {
      width: 9%;
      text-align: center;
   }

   .file-type {
      width: 8%;
      text-align: center;
   } 

   .status {
      width: 10%;
      text-align: center;
      span {
         background: gray;
         border-radius: 3px;
         text-align: center;
         font-size: 10px;
         text-transform: uppercase;
         padding: 4px 10px;
      }
   }

   // .check {
   //    // width: 50px;
   //    width: 65px;
   //    padding-left: 27px;
   // }

   // .loop {
   //    order: 6;
   // }

   // .hot-pick {
   //    order: 7;
   // }

   // .no-ads {
   //    order: 8;
   // }

   .buttons-cell {
      width: 18%;

      .buttons-wrapper {
         display: flex;
      }

      .btn {
         width: 25px;
         height: 25px;

         background-size: 25px 25px;
      }
   }

    .order-col {
      position: relative;
   }

   .slot-order-wrapper {
      text-align: center;

      .slot-order {
         font-weight: 700;
         font-size: 2em;
      }

      .slot-slot {
         text-transform: uppercase;
         font-size: 12px;
         color: #65809c;
      }
   }

   .slot-asset-wrapper {
      display: flex;
      align-items: center;
      padding: 10px 0;
      overflow: hidden;

      &.add_margin {
         // margin-left: 10px;
      }
   }

   .slot-asset-type {
      text-transform: capitalize;
   }

   #asset_drop_zone {
      width: 100px;
      height: 75px;

      img {
         &:hover {
            cursor: pointer;
         }
      }
   }

   .asset-info-wrapper {
      margin-left: 10px;
      text-align: left;
      width: 134px;

      .asset-title {
         font-size: 14px;
         width: 100%;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: nowrap;

         &.italic {
            font-style: italic;
         }
      }

      .asset-created {
         color: #7f8fa4;
      }
   }

   .duration-input-wrapper {
      display: flex;
      border: 1px solid silver;
      width: fit-content;
      background: #223a55;

      input {
         width: 18px;
         color: white;
         border: none;
         background: transparent;

         &.left {
            text-align: right;
         }

         &.center {
            text-align: center;
         }

         &.right {
            text-align: left;
         }

         &:focus {
            outline: none;
         }
      }
   }

   .btn-drop {
      position: relative;
      left: -24px;
      top: 36px;

      padding: 0;
      border: 0;
      background-color: transparent;
      color: white;
      font-size: 14px;
      border-radius: 0px;

      &:hover {
         background-color: transparent;
         cursor: pointer;
         border: none;
         outline: none;
      }
      
      &:after {
         display: inline-block;
         width: 14px;
         height: 14px;
         margin-left: 24px;
         content: '';
         border: 0;
         background-image: url(../../../assets/img/instances/SVGs/arrow-right.svg);
         background-repeat: no-repeat;
         background-size: 14px 14px;
      }

      &.expanded:after {
         background-image: url('../../../assets/img/instances/SVGs/arrow-down.svg');
      }
   }

   .thumb-wrapper {
      width: 100px;
      height: 75px;
      background: black;
      text-align: center;
      position:relative;

      &.selected {
         border: 1px solid $block-selected;
      }
   }

   .img-overlay {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 75px;
      background: #000;
      opacity: .8;
      background-image: url('./../../../assets/img/drag-and-drop-active.svg');
      background-repeat: no-repeat;
      background-position: 7px 4px;
      background-size: 90% 90%;

      &.active {
         display: block;
      }
   }

   .slot-asset-thumb {
      max-width: 100px;
      max-height: 73px;

      &:hover {
         cursor: pointer;
      }
   }

   .edit-btn {
      background: url('../../../assets/img/global/SVGs/BTTN_edit_icon.svg') no-repeat left center transparent; 

      &:hover,
      &:focus,
      &:active {
         cursor: pointer;
      }
   }

   .delete-btn {
      background: url('../../../assets/img/instances/SVGs/bttn_delete.svg') no-repeat left center transparent; 

      &:hover,
      &:focus,
      &:active {
         background-image: url('../../../assets/img/instances/SVGs/bttn_delete-active.svg');
         cursor: pointer;
      }
   }

   .trigger-btn {
      background: #2fb242;
      border-radius: 2px;
      width: 63px;
      font-size: 12px;
      margin-right: 7px;
      text-align: center;
      padding: 5px 0;
      text-transform: uppercase;
      transition: all .25s ease;

      &:hover {
         cursor: pointer;
         background: white;
         color: #2fb242;
      }
   }
}

//hide the spin button 
//https://stackoverflow.com/questions/3790935/can-i-hide-the-html5-number-input-s-spin-box
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>